import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import * as types from "../../constants/actionTypes";
import { messages, messagesRedirect, success, deleteData } from "../../components/messageBox";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";
import { setLoader } from "./actions";
import moment from "moment";

const getStateDashboard = (state) => state.Dashboard;

export function* getListReservasi(params) {
  try {
    yield put(setLoader(true));

    let stateDashboard = yield select(getStateDashboard);
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    const _body = {
      id: _id,
      statusReservasi: params.value,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DASHBOARD_LIST_RESERVASI_POST, _body, { headers: Header() });

    if (response.acknowledge == 1) {
      yield put({ type: types.GET_LIST_RESERVASI_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
  }
}

export function* acceptReservasi(params) {
  try {
    yield put(setLoader(true));

    const _body = {
      id: params.id,
      isAccept: params.isAccept,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DASHBOARD_ACCEPT_POST, _body, { headers: Header() });

    if (response.acknowledge == 1) {
      messages("Berhasil", response.message, "success", false, false);
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield call(getListReservasi, 0);
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
  }
}

export function* logoutUser(params) {
  try {
    yield put(setLoader(true));

    localStorage.removeItem("UserData");
    messagesRedirect("Logout Berhasil", "Anda akan di redirect ke halaman login.", "success", false, params.history, `/`);

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
  }
}

export function* reportKunjunganPasien(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      id: _id,
      days: params.value,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_REPORT_LIST_KUNJUNGAN_PASIEN_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* pemasukanHarian() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      id: _id,
      currentDate: moment().format("YYYY-MM-DD"),
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_KASIR_PEMASUKAN_HARIAN_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.DASHBOARD_ADMISI_PEMASUKAN_HARIAN_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.GET_LIST_RESERVASI, getListReservasi),
    takeLatest(types.DASHBOARD_ADMISI_ACCEPT_RESERVASI, acceptReservasi),
    takeLatest(types.MODULE_AUTH_LOGOUT, logoutUser),
    takeLatest(types.DASHBOARD_ADMISI_LISTDATA_KUNJUNGAN_PASIEN, reportKunjunganPasien),
    takeLatest(types.DASHBOARD_ADMISI_PEMASUKAN_HARIAN, pemasukanHarian),
  ]);
}
